<template>
  <div
    v-loading.fullscreen.lock="isSearching"
    element-loading-text="กำลังค้นหาข้อมูล..."
    class="biller-page biller-profile-detail-page page-content">
    <el-row
      class="page-header -with-back-button -with-action-buttons"
      type="flex"
      style="margin-bottom: 0;"
      justify="space-between">
      <el-col :span="24">
        <el-button type="primary"
                   icon="el-icon-back"
                   class="back-button"
                   @click.prevent="goBack">
        </el-button>
        <h2 class="page-title">รายละเอียดข้อมูลบริษัทสำหรับรับชำระ</h2>
        <div class="action-buttons">
          <!--<el-button type="primary" class="action-button" @click.prevent="addPayer">
            เพิ่มผู้ชำระใหม่ <i class="el-icon-plus el-icon-right"></i>
          </el-button>-->
          <el-dropdown
            split-button
            type="primary"
            class="action-button"
            @click.prevent="addPayer"
            trigger="click"
            @command="handleImportSlipsCommand">
            เพิ่มผู้ชำระใหม่ <i class="el-icon-plus el-icon-right"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="import">นำเข้าด้วยไฟล์ Excel (XLSX)</el-dropdown-item>
              <el-dropdown-item command="import-csv">นำเข้าด้วยไฟล์ CSV</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="default" class="action-button" v-if="isBillerAdmin" @click.prevent="editProfile">
            แก้ไขข้อมูลบริษัทสำหรับรับชำระ <i class="el-icon-edit el-icon-right"></i>
          </el-button>
        </div>
      </el-col>
    </el-row>

    <div
      class="company-form company-detail-info profile-detail-info"
      style="background:#f9f9fa;border-bottom: 1px solid #ccc;padding: 20px 0 0;margin-bottom: 20px;"
      v-if="profile">
      <el-row class="detail-section">
        <el-row class="detail-row" style="margin-bottom:0;">
          <el-col :span="24" class="biller-profile-logo-holder">
            <el-row>
              <el-col :span="3">
                <div class="logo-holder" v-if="profile.logo" style="margin: 0 auto;">
                  <img :src="profile.logo" class="logo"/>
                </div>
              </el-col>
              <el-col :span="7">
                <el-row>
                  <el-col :span="24" class="label">
                    ชื่อข้อมูลบริษัทสำหรับรับชำระ
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    {{ profile.name }}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="14">
                <el-row>
                  <el-col :span="8" class="label row-center">
                    COMP CODE
                  </el-col>
                  <el-col :span="8" class="label row-center">
                    หมายเลขบัญชี
                  </el-col>
                  <el-col :span="8" class="label row-center">
                    Biller ID
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8" class="row-center">
                    {{ profile.bill_payment_comp_code || '-'}}
                  </el-col>
                  <!--<el-col :span="8">
                    {{ accountNoFormatter(profile.bill_payment_account_no) }}
                  </el-col>-->
                  <el-col :span="8" class="bill-payment-info-row row-center">
                    <div
                      class="bill-payment-info-row"
                      v-if="profile.account_no"
                      v-html="accountNoAllFormatter(profile.account_no)"></div>
                  </el-col>
                  <el-col :span="8" class="row-center">
                    {{ profile.bill_payment_biller_id || '-'}}
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-row>
    </div>

    <div class="slip-search-filter">
      <el-row>
        <el-col :span="24">
          <h3 class="title">ค้นหารายการผู้ชำระ</h3>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-collapse
            v-model="slipSearchOption"
            @change="searchOptionCollapseChange"
            class="search-option-collapse">
            <el-collapse-item
              title="ตัวเลือกการค้นหา"
              name="1">
              <template slot="title">
                <div v-if="slipSearchOption.indexOf('1') === -1">
                  <i class="el-icon-circle-plus-outline"></i> แสดงตัวเลือกการค้นหา
                  <span class="filter-count" v-if="filterAppliedCount > 0">(กำลังใช้งานอยู่ {{ filterAppliedCount }} ตัวเลือก)</span>
                </div>
                <div v-else class="hide-search-option-btn">
                  <i class="el-icon-remove-outline"></i> ซ่อนตัวเลือกการค้นหา
                  <span class="filter-count" v-if="filterAppliedCount > 0">(กำลังใช้งานอยู่ {{ filterAppliedCount }} ตัวเลือก)</span>
                </div>
              </template>
              <el-form
                v-if="profile"
                :model="searchForm"
                ref="searchForm"
                label-width="120px"
                label-position="top"
                @submit.native.prevent="submitForm()"
                class="slip-search-form"
                :disabled="isSearching">
                <el-row class="option-group-label">
                  <el-col :span="23">
                    <label class="el-form-item__label">วันที่ครบกำหนดชำระ</label>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="11">
                    <el-form-item label="ตั้งแต่วันที่">
                      <el-date-picker
                        v-model="searchForm.issued_on__from"
                        type="date"
                        placeholder="เลือกวันเริ่มต้น"
                        :picker-options="searchPickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11" :offset="1">
                    <el-form-item label="ถึงวันที่">
                      <el-date-picker
                        v-model="searchForm.issued_on__to"
                        type="date"
                        placeholder="เลือกวันเริ่มต้น"
                        :picker-options="searchPickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="23">
                    <el-form-item label="ชื่อผู้ชำระ">
                      <el-input
                        v-model="searchForm.payee__name"
                        id="searchForm.payee__name"
                        placeholder="กรอกชื่อผู้ชำระ"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="11">
                    <el-form-item :label="ref1Label">
                      <el-input
                        v-model="searchForm.ref1"
                        id="searchForm.ref1"
                        @change="updateMaskRefCode"
                        ref="searchForm.ref1"
                        @input.native="handleInput($event, 'searchForm.ref1', 'refCode')"
                        :placeholder="`กรอก${ref1Label}`"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11" :offset="1">
                    <el-form-item :label="ref2Label">
                      <el-input
                        v-model="searchForm.ref2"
                        id="searchForm.ref2"
                        @change="updateMaskRefCode"
                        ref="searchForm.ref2"
                        @input.native="handleInput($event, 'searchForm.ref2', 'refCode')"
                        :placeholder="`กรอก${ref2Label}`"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="option-group-label">
                  <el-col :span="23">
                    <label class="el-form-item__label">จำนวนเงิน (บาท)</label>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="11">
                    <el-form-item label="ตั้งแต่">
                      <el-input
                        v-model="searchForm.amount__from"
                        id="searchForm.amount__from"
                        @change="updateMaskAmount('amount__from')"
                        ref="searchForm.amount__from"
                        @input.native="handleInput($event, 'searchForm.amount__from', 'amountMask')"
                        placeholder="กรอกจำนวนเงิน"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11" :offset="1">
                    <el-form-item label="ถึง">
                      <el-input
                        v-model="searchForm.amount__to"
                        id="searchForm.amount__to"
                        @change="updateMaskAmount('amount__to')"
                        ref="searchForm.amount__to"
                        @input.native="handleInput($event, 'searchForm.amount__to', 'amountMask')"
                        placeholder="กรอกจำนวนเงิน"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="23">
                    <el-form-item label="พิมพ์แล้ว?">
                      <el-radio-group v-model="searchForm.is_printed">
                        <el-radio-button label="ทั้งหมด"></el-radio-button>
                        <el-radio-button label="พิมพ์แล้ว"></el-radio-button>
                        <el-radio-button label="ยังไม่พิมพ์"></el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="23">
                    <el-form-item label="ส่งอีเมลแล้ว?">
                      <el-radio-group v-model="searchForm.is_sent">
                        <el-radio-button label="ทั้งหมด"></el-radio-button>
                        <el-radio-button label="ส่งแล้ว"></el-radio-button>
                        <el-radio-button label="ยังไม่ส่ง"></el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="search-option-buttons">
                  <el-col :span="23">
                    <el-form-item size="large">
                      <el-button
                        type="primary"
                        plain
                        class="cancel-btn"
                        @click="resetForm"
                        id="searchForm.resetButton">ล้างค่า</el-button>
                      <el-button
                        native-type="submit"
                        type="primary"
                        class="search-btn"
                        icon="el-icon-search">ค้นหา</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </div>

    <div
      v-loading.fullscreen.lock="isPrinting || isEmailing || isDeleting || isExporting"
      :element-loading-text="slipLoadingActionText"
      class="slip-list-table">
      <div class="control-panel">
        <el-row>
          <el-col :span="6">
            <h3 class="title">รายการผู้ชำระ</h3>
          </el-col>
          <el-col :span="18">
            <div class="action-buttons" v-if="selectedSlips.length > 0">
              <div class="slip-selected-count">
                <el-button type="text" @click.prevent="clearSelection">(ล้างค่าการเลือก)</el-button> เลือกอยู่ {{ selectedSlips.length }} รายการ :
              </div>
              <el-button type="danger" plain icon="el-icon-delete" @click="requestDelete">ลบรายการ</el-button>
              <!--<el-button type="default" plain icon="el-icon-document" @click="requestExport">ส่งออก</el-button>-->
              <el-dropdown trigger="click" @command="handleExportCommand">
                <el-button type="default">
                  ส่งออก<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="xlsx">ไฟล์ Excel (XLSX)</el-dropdown-item>
                  <el-dropdown-item command="csv">ไฟล์ CSV</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown trigger="click" @command="handlePrintCommand">
                <el-button type="default">
                  พิมพ์<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="pay-in">Pay-in slip(s)</el-dropdown-item>
                  <el-dropdown-item command="qr" v-if="canGenerateQR">รูปภาพ QR Code</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown trigger="click" @command="handleEmailCommand">
                <el-button type="default">
                  ส่งอีเมล<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="pay-in">Pay-in slip(s)</el-dropdown-item>
                  <el-dropdown-item command="qr" v-if="canGenerateQR">รูปภาพ QR Code</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-button type="default" plain icon="el-icon-tickets" @click="requestSummary">ดูรายการสรุป</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-pagination
        v-if="slipListDataTotalPage > 1"
        layout="prev, pager, next, jumper"
        background
        @current-change="updateSlipListDataRows"
        :current-page.sync="slipListDataCurrentPage"
        :page-size="slipListDataItemPerPage"
        :total="slipListTotalItem">
      </el-pagination>
      <el-table
        class="slip-list-table"
        ref="slipListTable"
        :data="slipListDataPaged"
        :default-sort = "{prop: 'issued_on', order: 'descending'}"
        @select="handleSelectRow"
        @select-all="handleSelectAll"
        show-summary
        :summary-method="sumPagedSlips"
        @sort-change="dataTableSorted"
        v-loading="isSortingData"
        style="width: 100%">
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          fixed="left"
          width="50">
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="id"
          label="ID"
          class-name="no-wrap"
          min-width="50">
        </el-table-column>
        <el-table-column
          prop="issued_on"
          label="วันที่ชำระ"
          width="100"
          fixed="left"
          sortable="custom"
          :formatter="dateFormatter">
        </el-table-column>
        <el-table-column
          prop="payer.name"
          label="ชื่อลูกค้า"
          class-name="no-wrap"
          min-width="120"
          sortable="custom">
        </el-table-column>
        <el-table-column
          prop="ref1"
          label="Ref.1"
          min-width="150"
          class-name="no-wrap"
          sortable="custom">
        </el-table-column>
        <el-table-column
          prop="ref2"
          label="Ref.2"
          min-width="150"
          class-name="no-wrap"
          sortable="custom">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="ยอดเงิน"
          header-align="right"
          align="right"
          sortable="custom"
          class-name="no-wrap"
          min-width="120"
          :formatter="amountFormatter">
        </el-table-column>
        <el-table-column
          prop="print_status"
          label="Print"
          align="left"
          header-align="left"
          width="80">
          <template slot-scope="scope">
            <div class="status-row" :class="scope.row.print_status.payin ? 'success' : 'fail'">
              <span>Pay-in:</span>
              <i :class="scope.row.print_status.payin ? 'el-icon-check' : 'el-icon-minus'"></i>
            </div>
            <div class="status-row" :class="scope.row.print_status.qr ? 'success' : 'fail'">
              <span>QR:</span>
              <i :class="scope.row.print_status.qr ? 'el-icon-check' : 'el-icon-minus'"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="email_status"
          label="Email"
          align="left"
          header-align="left"
          width="100">
          <template slot-scope="scope">
            <div class="status-row" :class="scope.row.email_status.payin ? 'success' : 'fail'">
              <span>Pay-in:</span>
              <i :class="scope.row.email_status.payin ? 'el-icon-check' : 'el-icon-minus'"></i>
            </div>
            <div class="status-row" :class="scope.row.email_status.qr ? 'success' : 'fail'">
              <span>QR:</span>
              <i :class="scope.row.email_status.qr ? 'el-icon-check' : 'el-icon-minus'"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="ตัวเลือก"
          header-align="center"
          align="center"
          class-name="action-col"
          width="100">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="mini"
              @click.prevent="handleEdit(scope.$index, scope.row)"
              class="action-btn">แก้ไข</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="slipListDataTotalPage > 1"
        layout="prev, pager, next, jumper"
        background
        @current-change="updateSlipListDataRows"
        :current-page.sync="slipListDataCurrentPage"
        :page-size="slipListDataItemPerPage"
        :total="slipListTotalItem">
      </el-pagination>
    </div>
    <a
      id="slip-pdf-content"
      v-if="pdfContent"
      :href="pdfContent"
      :download="pdfFilename"></a>
    <el-dialog
      :fullscreen="true"
      :title="summaryDialogTitle"
      :visible.sync="isSummaryDialogShown">
      <el-table
        show-summary
        :summary-method="sumSlips"
        :data="summaryGridData">
        <el-table-column
          type="index"
          fixed="left"
          header-align="center"
          align="center"
          min-width="50">
        </el-table-column>
        <el-table-column
          prop="issued_on"
          label="วันที่ชำระ"
          width="120"
          :formatter="dateFormatter">
        </el-table-column>
        <el-table-column
          prop="payer.name"
          label="ชื่อลูกค้า"
          min-width="140"
          class="no-wrap">
        </el-table-column>
        <el-table-column
          prop="ref1"
          :label="ref1Label"
          width="200">
        </el-table-column>
        <el-table-column
          prop="ref2"
          :label="ref2Label"
          width="200">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="จำนวนเงิน (บาท)"
          align="right"
          width="200"
          :formatter="amountFormatter">
        </el-table-column>
      </el-table>
      <div id="not-email-list" v-if="summaryDialogMode === 'email' && summaryGridData2.length > 0">
        <hr/>
        <h4 style="color:red;">** รายการด้านล่างนี้จะไม่ถูกส่งไปทางอีเมล เนื่องจากไม่มีอีเมลระบุไว้ **</h4>
        <el-table
          show-summary
          :summary-method="sumSlips"
          :data="summaryGridData2">
          <el-table-column
            type="index"
            fixed="left"
            header-align="center"
            align="center"
            min-width="50">
          </el-table-column>
          <el-table-column
            prop="issued_on"
            label="วันที่ชำระ"
            width="120"
            :formatter="dateFormatter">
          </el-table-column>
          <el-table-column
            prop="payer.name"
            label="ชื่อลูกค้า"
            min-width="140"
            class="no-wrap">
          </el-table-column>
          <el-table-column
            prop="ref1"
            :label="ref1Label"
            width="200">
          </el-table-column>
          <el-table-column
            prop="ref2"
            :label="ref2Label"
            width="200">
          </el-table-column>
          <el-table-column
            prop="amount"
            label="จำนวนเงิน (บาท)"
            align="right"
            width="200"
            :formatter="amountFormatter">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSummaryDialog">{{ 'Cancel' | translate }}</el-button>
        <el-button
          v-if="['print', 'export'].indexOf(summaryDialogMode) !== -1 ||
          (['email'].indexOf(summaryDialogMode) !== -1 && summaryGridData.length > 0)"
          type="primary"
          @click="confirmSummaryDialog">{{ 'Confirm' | translate }}</el-button>
        <el-button v-if="summaryDialogMode === 'delete'" type="danger" icon="el-icon-delete" @click="confirmSummaryDialog">ยืนยันลบข้อมูล</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="import-dialog"
      :fullscreen="true"
      :title="importDialogTitle"
      :visible.sync="isImportDialogShown"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="cancelImportDialog">
      <div v-if="isImporting" class="importing-icon">
        <i class="el-icon-loading icon"></i><br/>
        <h4 class="loading-text">กำลังประมวลผล...</h4>
      </div>
      <div class="xls-uploader-holder" v-if="!isImporting && xlsDataRows.length === 0 && xlsErrorRows.length === 0 && xlsSkipRows.length === 0">
        <div class="template-download-instruction">
          กรุณาใช้รูปแบบ {{ importFileFormatName }} ที่กำหนดเพื่อการนำเข้าข้อมูลที่ถูกต้อง
          <a href="#" @click.prevent="downloadXLSTemplate">ดาวน์โหลดรูปแบบ</a>
        </div>
        <el-upload
          class="xls-uploader"
          action=""
          drag
          :show-file-list="false"
          :before-upload="handleBeforeXLSUpload"
          :http-request="handleXLSImport">
          <i class="icon el-icon-document"></i>
          <div class="el-upload__text">
            เลือกไฟล์ {{ importFileFormatName }} ที่ต้องการ หรือลากมาวางที่นี่เพื่อเริ่มนำเข้าข้อมูล<br/>
            <br/>
            <div>
              <span class="el-button el-button--primary">เลือกไฟล์</span>
            </div>
          </div>
        </el-upload>
      </div>
      <el-row
        v-if="!isImporting && (xlsDataRows.length > 0 || xlsErrorRows.length > 0 || xlsSkipRows.length > 0)"
        class="import-summary-table">
        <el-col :span="24">
          <el-row>
            <el-col :span="24">
              <h3 class="import-summary-header">สรุปรายการเพื่อนำเข้า</h3>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" class="header-label">
              จำนวนรายการที่สามารถนำเข้า
            </el-col>
            <el-col :span="8" class="header-label">
              จำนวนรายการที่ข้าม(ข้อมูลไม่ครบ)
            </el-col>
            <el-col :span="8" class="header-label">
              จำนวนรายการที่มีปัญหา
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" class="value-label import-row-count">
              {{ numFormat(xlsDataRows.length) }}
            </el-col>
            <el-col :span="8" class="value-label skip-row-count">
              {{ numFormat(xlsSkipRows.length) }}
            </el-col>
            <el-col :span="8" class="value-label error-row-count">
              {{ numFormat(xlsErrorRows.length) }}
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="xls-data-preview" v-if="!isImporting && xlsDataRows.length > 0">
        <!--<el-pagination
          layout="prev, pager, next"
          @current-page="updateImportDataRows"
          :current-page.sync="xlsDataCurrentPage"
          :page-size="xlsDataItemPerPage"
          :total="xlsDataRows.length">
        </el-pagination>-->
        <el-table
          max-height="300"
          show-summary
          :summary-method="sumImportSlips"
          v-loading="isSortingImport"
          :data="xlsDataRowsPaged">
          <el-table-column
            prop="rowNumber"
            label="No."
            header-align="center"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            type="id"
            prop="id"
            label="ID"
            header-align="center"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            prop="issued_on"
            :label="xlsTemplateHeaders[5]"
            width="180"
            :formatter="dateFormatter">
          </el-table-column>
          <el-table-column
            prop="payer.name"
            :label="xlsTemplateHeaders[1]"
            width="180">
          </el-table-column>
          <el-table-column
            prop="payer.email"
            :label="xlsTemplateHeaders[6]"
            width="180">
          </el-table-column>
          <el-table-column
            prop="ref1"
            :label="xlsTemplateHeaders[2]"
            width="200">
          </el-table-column>
          <el-table-column
            prop="ref2"
            :label="xlsTemplateHeaders[3]"
            width="200">
          </el-table-column>
          <el-table-column
            prop="amount"
            :label="xlsTemplateHeaders[4]"
            align="right"
            width="200"
            :formatter="amountFormatter">
          </el-table-column>
          <el-table-column
            prop="notification_msg"
            :label="xlsTemplateHeaders[7]"
            class-name="no-wrap notification_msg-col"
            width="200">
          </el-table-column>
          <el-table-column
            prop="remark"
            :label="xlsTemplateHeaders[8]"
            align="right"
            width="200">
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="xlsDataTotalPage > 1"
          layout="prev, pager, next, jumper"
          background
          :current-page.sync="xlsDataCurrentPage"
          :page-size="xlsDataItemPerPage"
          :total="xlsDataRows.length">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isImporting">
        <el-button
          v-if="!isImporting"
          @click="cancelImportDialog">{{ 'Cancel' | translate }}</el-button>
        <el-button
          v-if="!isImporting && xlsDataRows.length > 0"
          type="primary"
          @click="confirmImportDialog">ยืนยันการนำเข้า</el-button>
      </span>
    </el-dialog>
    <el-dialog
      id="summaryPdfViewerDialog"
      title="รายงานสรุปยอด"
      :fullscreen="true"
      :before-close="closeSummaryResultDialog"
      :visible.sync="isSummaryResultDialogShown">
      <iframe id="summaryPdfViewer" v-if="isSummaryResultDialogShown" :src="summaryPDFDataURL"></iframe>
    </el-dialog>
  </div>
</template>

<script>
  /* eslint no-param-reassign: 0 */
  /* eslint new-cap: 0 */
  import moment from 'moment-timezone';
  import numeral from 'numeral';
  import { createMask, MaskedNumber } from 'imask';
  import helpers from '@/libs/helpers';
  import _ from 'lodash';
  import FileSaver from 'file-saver';
  import XLSX from 'xlsx';
  import pdfMake from 'pdfmake/build/pdfmake';
  import pdffonts from '@/libs/pdffonts';
  import XRegExp from 'xregexp';
  import Raven from 'raven-js';
  import Papa from 'papaparse';
  // import asyncMergeSort from 'async-merge-sort';

  const defaultOffset = 0;
  const defaultLimit = 100;

  const xlsxTemplateHeadersArray = [
    'ID',
    'Payer Name * (40)',
    'Ref.1 * (Max 20)',
    'Ref.2 (Max 20)',
    'Amount *',
    'Payment Date * (dd/mm/yy) yy = 18',
    'Email Address',
    'Alert Message (100)',
    'Remark (100)',
  ];

  const BillerProfileDetailView = {
    name: 'biller-profile-detail',
    props: ['profileId'],
    data() {
      return {
        isSearching: false,
        isPrinting: false,
        isEmailing: false,
        isDeleting: false,
        isExporting: false,
        isImporting: false,
        isSortingImport: false,
        isSortingData: false,
        isChangingPage: false,
        xlsUpdateFile: null,
        xlsDataRows: [],
        xlsDataRowsSorted: [],
        xlsDataCurrentPage: 1,
        xlsDataItemPerPage: 100,
        slipListDataSorted: [],
        slipListDataCurrentPage: 1,
        slipListDataItemPerPage: defaultLimit,
        xlsSkipRows: [],
        xlsErrorRows: [],
        activeSearchOption: ['1'],
        searchPickerOptions: {
          /* disabledDate(time) {
            return time.getTime() > Date.now();
          }, */
          shortcuts: [{
            text: 'วันนี้',
            onClick(picker) {
              picker.$emit('pick', new Date());
            },
          }, {
            text: 'เมื่อวานนี้',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - (3600 * 1000 * 24));
              picker.$emit('pick', date);
            },
          }, {
            text: 'สัปดาห์ก่อน',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - (3600 * 1000 * 24 * 7));
              picker.$emit('pick', date);
            },
          }],
        },
        summaryDialogMode: '',
        summaryDialogRequest: '',
        summaryDialogTitle: '',
        exportFileFormat: 'xlsx',
        importFileFormat: 'xlsx',
        isSummaryDialogShown: false,
        isImportDialogShown: false,
        isSummaryResultDialogShown: false,
        summaryPDFDataURL: null,
        pdfFilename: '',
        pdfContent: null,
        // selectedSlips: [],
        selectedSlipsPaged: {},
        searchForm: {
          amount__from: null,
          amount__to: null,
          issued_on__from: null,
          issued_on__to: null,
          payee__name: null,
          ref1: null,
          ref2: null,
          is_printed: 'ทั้งหมด',
          limit: defaultLimit,
          offset: defaultOffset,
          id__in: null,
          is_sent: 'ทั้งหมด',
          order_by: 'issued_on',
          order_dir: 'desc',
        },
        mask: {
          accountNo: {
            mask: '000-0-00000-0',
          },
          amountMask: {
            mask: MaskedNumber,
            scale: 2,
            signed: false,
            thousandsSeparator: ',',
            padFractionalZeros: true,
            normalizeZeros: true,
            radix: '.',
            mapToRadix: ['.'],
          },
          telMask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
            { mask: '{0}00-000-0000' },
          ],
          faxMask: [
            { mask: '{02}-000-0000' },
            { mask: '{0}00-000-000' },
          ],
          refCode: {
            mask: /^[0-9A-Z]{0,20}$/,
          },
        },
      };
    },
    computed: {
      isAuthenticated() {
        return this.$store.getters.idToken;
      },
      isBillerAdmin() {
        if (this.$store.getters.myAdminInfo) {
          return this.$store.getters.myAdminInfo.role === 'ADMIN';
        }
        return false;
      },
      canGenerateQR() {
        if (this.profile) {
          return this.profile.barcode_qrcode_biller_id_tax_id !== null &&
            this.profile.barcode_qrcode_biller_id_tax_id !== '';
        }
        return false;
      },
      importDialogTitle() {
        if (this.importFileFormat === 'xlsx') {
          return 'นำเข้ารายการด้วย Excel (XSLX)';
        }
        return 'นำเข้ารายการด้วย CSV';
      },
      importFileFormatName() {
        if (this.importFileFormat === 'xlsx') {
          return 'Excel (XLSX)';
        }
        return 'CSV';
      },
      /* hasQRAccountNo() {
        if (this.profile) {
          return this.profile.barcode_qrcode_account_no !== null &&
            this.profile.barcode_qrcode_account_no !== '';
        }
        return null;
      }, */
      company() {
        return this.$store.getters.billerInfo;
      },
      profile() {
        const profile = JSON.parse(JSON.stringify(this.$store.getters.currentBillerProfile));
        if (profile) {
          const billPaymentAccountNo = this.maskFormatter(profile.bill_payment_account_no,
            this.mask.accountNo);
          let qrAccountNo = null;
          if (profile.barcode_qrcode_account_no) {
            const acc = this.maskFormatter(profile.barcode_qrcode_account_no, this.mask.accountNo);
            qrAccountNo = `${acc} (${profile.barcode_qrcode_account_no_suffix})`;
          }
          profile.account_no = {
            bill_payment: billPaymentAccountNo,
            qr: qrAccountNo,
          };
        }
        return profile;
      },
      slipList() {
        return this.$store.getters.billerSlipList;
      },
      slipListData() {
        return JSON.parse(JSON.stringify(this.slipList)).map((slip) => {
          // construct print status
          slip.print_status = {
            payin: slip.is_printed || false,
            qr: slip.is_printed_qr_image || false,
          };
          // construct email status
          slip.email_status = {
            payin: slip.is_sent || false,
            qr: slip.is_sent_qr_image || false,
          };
          return slip;
        });
      },
      ref1Label() {
        if (this.profile) {
          return `${this.profile.label_ref1} (Ref. 1)`;
        }
        return '';
      },
      ref2Label() {
        if (this.profile) {
          return `${this.profile.label_ref2} (Ref. 2)`;
        }
        return '';
      },
      slipLoadingActionText() {
        if (this.isPrinting) {
          return 'กำลังพิมพ์...';
        } else if (this.isEmailing) {
          return 'กำลังส่งอีเมล...';
        } else if (this.isDeleting) {
          return 'กำลังลบ...';
        } else if (this.isExporting) {
          return 'กำลังส่งออก...';
        }
        return '';
      },
      summaryGridData() {
        const slipList = [];
        if (this.summaryDialogMode === 'email') {
          /* return this.slipListData.filter(slip => this.selectedSlips.indexOf(slip.id) !== -1 &&
            slip.payer.email.trim() !== ''); */
          /* this.selectedSlips.forEach((slipId) => {
            this.slipListData.forEach((slip) => {
              if (slip.id === slipId && slip.payer.email.trim() !== '') {
                slipList.push(slip);
              }
            });
          }); */
          Object.keys(this.selectedSlipsPaged).forEach((paged) => {
            this.selectedSlipsPaged[paged].forEach((slip) => {
              if (slip.payer.email && slip.payer.email.trim() !== '') {
                slipList.push(slip);
              }
            });
          });
        } else {
          /* this.selectedSlips.forEach((slipId) => {
            this.slipListData.forEach((slip) => {
              if (slip.id === slipId) {
                slipList.push(slip);
              }
            });
          }); */
          Object.keys(this.selectedSlipsPaged).forEach((paged) => {
            this.selectedSlipsPaged[paged].forEach((slip) => {
              slipList.push(slip);
            });
          });
        }
        return slipList;
        // return this.slipListData.filter(slip => this.selectedSlips.indexOf(slip.id) !== -1);
      },
      summaryGridData2() {
        if (this.summaryDialogMode !== 'email') {
          return null;
        }
        const slipList = [];
        /* return this.slipListData.filter(slip => this.selectedSlips.indexOf(slip.id) !== -1 &&
          slip.payer.email.trim() === ''); */
        /* this.selectedSlips.forEach((slipId) => {
          this.slipListData.forEach((slip) => {
            if (slip.id === slipId && slip.payer.email.trim() === '') {
              slipList.push(slip);
            }
          });
        }); */
        Object.keys(this.selectedSlipsPaged).forEach((paged) => {
          this.selectedSlipsPaged[paged].forEach((slip) => {
            if (slip.payer.email === null || slip.payer.email.trim() === '') {
              slipList.push(slip);
            }
          });
        });
        return slipList;
      },
      xlsTemplateHeaders() {
        return xlsxTemplateHeadersArray;
      },
      xlsTemplateHeadersKey() {
        const headerKeys = {};
        headerKeys[xlsxTemplateHeadersArray[0]] = 'id';
        headerKeys[xlsxTemplateHeadersArray[1]] = 'payer.name';
        headerKeys[xlsxTemplateHeadersArray[2]] = 'ref1';
        headerKeys[xlsxTemplateHeadersArray[3]] = 'ref2';
        headerKeys[xlsxTemplateHeadersArray[4]] = 'amount';
        headerKeys[xlsxTemplateHeadersArray[5]] = 'issued_on';
        headerKeys[xlsxTemplateHeadersArray[6]] = 'payer.email';
        headerKeys[xlsxTemplateHeadersArray[7]] = 'notification_msg';
        headerKeys[xlsxTemplateHeadersArray[8]] = 'remark';
        return headerKeys;
      },
      xlsExportHeaderKey() {
        return {
          id: xlsxTemplateHeadersArray[0],
          'payer.name': xlsxTemplateHeadersArray[1],
          'payer.email': xlsxTemplateHeadersArray[6],
          issued_on: xlsxTemplateHeadersArray[5],
          amount: xlsxTemplateHeadersArray[4],
          ref1: xlsxTemplateHeadersArray[2],
          ref2: xlsxTemplateHeadersArray[3],
          notification_msg: xlsxTemplateHeadersArray[7],
          remark: xlsxTemplateHeadersArray[8],
          // company_id: 'บริษัท',
          // created_at: 'สร้างเมื่อ',
          // emailed_at: 'ส่งอีเมลเมื่อ',
          // is_printed: 'พิมพ์แล้ว?',
          // is_sent: 'ส่งอีเมลแล้ว?',
          // payer: 'ลูกค้า',
          // printed_at: 'พิมพ์เมื่อ',
          // profile_id: 'บัญชีสำหรับรับชำระ',
          // updated_at: 'แก้ไขล่าสุดเมื่อ',
        };
      },
      slipSearchOption: {
        get() {
          return this.$store.getters.slipSearchOption;
        },
        set() {},
      },
      filterAppliedCount() {
        const searchQueryFilter = this.$store.getters.slipSearchQuery;
        if (searchQueryFilter) {
          return Object.keys(searchQueryFilter).filter((key) => {
            if (['order_by', 'order_dir', 'offset', 'limit'].indexOf(key) !== -1) return false;
            return searchQueryFilter[key] !== null;
          }).length;
        }
        return 0;
      },
      // table filter
      slipFilterDate() {
        return this.slipListData
          .map(item => item.issued_on)
          .filter((val, index, self) => self.indexOf(val) === index)
          .map((val) => {
            const data = {
              text: val,
              value: val,
            };
            return data;
          });
      },
      slipFilterName() {
        return this.slipListData
          .map(item => item.payer.name)
          .filter((val, index, self) => self.indexOf(val) === index)
          .map((val) => {
            const data = {
              text: val,
              value: val,
            };
            return data;
          });
      },
      xlsDataRowsPaged() {
        // apply pagination data
        let offsetIndex = (this.xlsDataCurrentPage - 1) * this.xlsDataItemPerPage;
        let offsetEndIndex = offsetIndex + this.xlsDataItemPerPage;
        if (offsetIndex >= this.xlsDataRows.length) {
          offsetIndex = this.xlsDataRows.length - 1;
        }
        if (offsetEndIndex > this.xlsDataRows.length) {
          offsetEndIndex = this.xlsDataRows.length;
        }
        return this.xlsDataRowsSorted.slice(offsetIndex, offsetEndIndex);
      },
      xlsDataTotalPage() {
        return Math.ceil(this.xlsDataRows.length / this.xlsDataItemPerPage);
      },
      slipListDataPaged() {
        // apply pagination data
        /* let offsetIndex = (this.slipListDataCurrentPage - 1) * this.slipListDataItemPerPage;
        let offsetEndIndex = offsetIndex + this.slipListDataItemPerPage;
        if (offsetIndex >= this.slipListData.length) {
          offsetIndex = this.slipListData.length - 1;
        }
        if (offsetEndIndex > this.slipListData.length) {
          offsetEndIndex = this.slipListData.length;
        }
        return this.slipListDataSorted.slice(offsetIndex, offsetEndIndex); */
        return this.slipListDataSorted;
      },
      slipListTotalItem() {
        return this.$store.getters.billerSlipListTotalItem;
      },
      slipListDataTotalPage() {
        // return Math.ceil(this.slipListData.length / this.slipListDataItemPerPage);
        return Math.ceil(this.slipListTotalItem / this.slipListDataItemPerPage);
      },
      selectedSlips() {
        const slips = [];
        Object.keys(this.selectedSlipsPaged).forEach((page) => {
          /* this.selectedSlipsPaged[page].forEach((slipId) => {
            slips.push(slipId);
          }); */
          this.selectedSlipsPaged[page].forEach((slip) => {
            slips.push(slip.id);
          });
        });
        return slips;
      },
    },
    methods: {
      goBack() {
        this.$router.push({ name: 'BillerProfileList' });
      },
      numFormat(num) {
        if (num === 0) return '-';
        return numeral(num).format('0,0');
      },
      filterHandler(value, row, column) {
        const property = column.property;
        return row[property] === value;
      },
      search() {
        return new Promise((resolve, reject) => {
          const payload = JSON.parse(JSON.stringify(this.searchForm));
          // transform payload
          Object.keys(payload).forEach((key) => {
            if (payload[key] !== null) {
              if (payload[key].toString().trim() === '') {
                payload[key] = null;
              }
            }
          });
          // amount
          if (payload.amount__from) {
            this.unmaskValue(payload, 'amount__from', this.mask.amountMask);
            const amountFromValue = parseInt(payload.amount__from, 10);
            if (amountFromValue < 0) {
              payload.amount__from = null;
            }
          }
          if (payload.amount__to) {
            this.unmaskValue(payload, 'amount__to', this.mask.amountMask);
            const amountToValue = parseInt(payload.amount__to, 10);
            if (amountToValue < 0) {
              payload.amount__to = null;
            }
          }
          // is_printed
          if (payload.is_printed === 'พิมพ์แล้ว') {
            payload.is_printed = true;
          } else if (payload.is_printed === 'ยังไม่พิมพ์') {
            payload.is_printed = false;
          } else {
            payload.is_printed = null;
          }
          // is_sent
          if (payload.is_sent === 'ส่งแล้ว') {
            payload.is_sent = true;
          } else if (payload.is_sent === 'ยังไม่ส่ง') {
            payload.is_sent = false;
          } else {
            payload.is_sent = null;
          }
          const reqPayload = JSON.parse(JSON.stringify({
            profileId: this.profileId,
            payload,
          }));
          this.isSearching = true;
          this.$store.dispatch('GET_BILLER_SLIP_LIST', reqPayload).then(() => {
            this.isSearching = false;
            this.updatePagedSelection(this.slipListDataCurrentPage);
            resolve();
          }).catch((msg) => {
            this.isSearching = false;
            if (msg) {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
            } else {
              this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
            }
            reject();
          });
        });
      },
      dateFormatter(row, column, cellValue) {
        const date = moment(cellValue).tz(process.env.DEFAULT_TZ);
        if (date.isValid()) {
          return date.format('ll');
        }
        return '-';
      },
      /* amountFormatter(row, column, cellValue) {
        return numeral(cellValue).format('0,0.00');
      }, */
      accountNoFormatter(val) {
        if (val) {
          return this.maskFormatter(val, this.mask.accountNo);
        }
        return '-';
      },
      accountNoAllFormatter(cellValue) {
        const { bill_payment: billPayment, qr } = cellValue;
        const output = [];
        if (billPayment) {
          output.push(billPayment);
        }
        if (qr) {
          output.push(qr);
        }
        if (output.length > 0) {
          return output.join('<br/>');
        }
        return '-';
      },
      amountFormatter(row, column, cellValue) {
        return this.maskFormatter(cellValue, this.mask.amountMask);
      },
      maskFormatter(val, maskOptions) {
        const mask = createMask(maskOptions);
        if (val) {
          return mask.resolve(val.toString());
        }
        return '';
      },
      getFlagText(value) {
        return value ? 'Yes' : 'No';
      },
      handleSelectAll(selectionRows) {
        if (typeof this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`] === 'undefined') {
          this.$set(this.selectedSlipsPaged, `_${this.slipListDataCurrentPage}`, []);
        }
        this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`].splice(0);
        selectionRows.forEach((item) => {
          const slip = JSON.parse(JSON.stringify(item));
          /* if (this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`]
          .indexOf(item.id) === -1) {
            this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`].push(item.id);
          } */
          let isFound = false;
          this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`].forEach((selectedSlip) => {
            if (selectedSlip.id === item.id) {
              isFound = true;
            }
          });
          if (!isFound) {
            this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`].push(slip);
          }
        });
      },
      handleSelectRow(selectionRows) {
        if (typeof this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`] === 'undefined') {
          this.$set(this.selectedSlipsPaged, `_${this.slipListDataCurrentPage}`, []);
        }
        this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`].splice(0);
        selectionRows.forEach((item) => {
          const slip = JSON.parse(JSON.stringify(item));
          /* if (this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`]
          .indexOf(item.id) === -1) {
            this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`].push(item.id);
          } */
          let isFound = false;
          this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`].forEach((selectedSlip) => {
            if (selectedSlip.id === item.id) {
              isFound = true;
            }
          });
          if (!isFound) {
            this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`].push(slip);
          }
        });
      },
      addPayer() {
        this.$router.push({
          name: 'BillerSlipCreate',
          params: {
            profileId: this.profileId,
          },
        });
      },
      editProfile() {
        this.$router.push({
          name: 'BillerProfileEdit',
          params: {
            profileId: this.profileId,
          },
        });
      },
      handleEdit(index, row) {
        this.$router.push({
          name: 'BillerSlipEdit',
          params: {
            profileId: this.profileId,
            slipId: row.id,
          },
        });
      },
      requestSummary() {
        // ----- BUILD HEADER -----
        let startDate = 0;
        let endDate = 0;
        let startDateText = '';
        let endDateText = '';

        const summaryList = [];
        /* this.selectedSlips.forEach((slipId) => {
          this.slipListData.forEach((slip) => {
            if (slip.id === slipId) {
              summaryList.push(slip);
            }
          });
        }); */
        Object.keys(this.selectedSlipsPaged).forEach((paged) => {
          this.selectedSlipsPaged[paged].forEach((slip) => {
            summaryList.push(slip);
          });
        });

        const tableRows = [
          [
            { text: 'No.', bold: true, alignment: 'center' },
            { text: 'วันที่ชำระ', bold: true, alignment: 'center' },
            { text: 'ชื่อลูกค้า', bold: true, alignment: 'center' },
            { text: 'Ref.1', bold: true, alignment: 'center' },
            { text: 'Ref.2', bold: true, alignment: 'center' },
            { text: 'ยอดเงิน', bold: true, alignment: 'center' },
            { text: 'พิมพ์?', bold: true, alignment: 'center' },
            { text: 'อีเมล?', bold: true, alignment: 'center' },
          ],
        ];
        const itemCount = summaryList.length;
        let lineItemCount = 0;
        let amountSum = 0;
        summaryList.forEach((slip) => {
          lineItemCount += 1;
          amountSum += slip.amount;
          let issuedDateText = '';
          const issuedOnDate = moment(slip.issued_on).tz(process.env.DEFAULT_TZ);
          if (issuedOnDate.isValid()) {
            issuedDateText = issuedOnDate.format('ll');
            if (startDate === 0 || Number(issuedOnDate.format('X') < startDate)) {
              startDate = Number(issuedOnDate.format('X'));
            }
            if (endDate === 0 || Number(issuedOnDate.format('X') > endDate)) {
              endDate = Number(issuedOnDate.format('X'));
            }
          }
          tableRows.push([
            { text: lineItemCount, alignment: 'center' },
            { text: issuedDateText, alignment: 'center' },
            { text: slip.payer.name, alignment: 'left' },
            { text: slip.ref1 || '-', alignment: 'center' },
            { text: slip.ref2 || '-', alignment: 'center' },
            { text: numeral(slip.amount).format('0,0.00'), alignment: 'right' },
            { text: slip.is_printed ? 'พิมพ์แล้ว' : 'ยังไม่พิมพ์', alignment: 'center' },
            { text: slip.is_sent ? 'ส่งแล้ว' : 'ยังไม่ส่ง', alignment: 'center' },
          ]);
        });
        // add summary row
        tableRows.push([
          { text: '', border: [false, false, false, false] },
          { text: '', border: [false, false, false, false] },
          { text: `จำนวนทั้งหมด: ${itemCount}`, bold: true, alignment: 'left', border: [false, false, false, false] },
          { text: 'ยอดสุทธิ:', colSpan: 2, bold: true, alignment: 'right', border: [false, false, false, false] },
          {},
          { text: numeral(amountSum).format('0,0.00'), bold: true, alignment: 'right', border: [false, false, false, false] },
          { text: '', border: [false, false, false, false] },
          { text: '', border: [false, false, false, false] },
        ]);
        if (startDate !== 0) {
          const startDateObject = moment(startDate, 'X').tz(process.env.DEFAULT_TZ);
          startDateText = startDateObject.format('ll');
        }
        if (endDate !== 0) {
          const endDateObject = moment(endDate, 'X').tz(process.env.DEFAULT_TZ);
          endDateText = endDateObject.format('ll');
        }
        let summaryDate = '';
        if (startDate !== 0 && endDate !== 0) {
          summaryDate = `วันที่ครบกำหนดชำระ ${startDateText} — ${endDateText}`;
        }
        const printFlagText = this.searchForm.is_printed;
        const sentFlagText = this.searchForm.is_sent;

        summaryDate += ` (Print Flag: ${printFlagText}, Email Flag: ${sentFlagText})`;
        // -----------------------
        pdfMake.vfs = pdffonts;
        pdfMake.fonts = {
          ErgoCom: {
            normal: 'ErgoCom-Condensed.ttf',
            bold: 'ErgoCom-MediumCondensed.ttf',
          },
          pslxtext: {
            normal: 'pslxtext-webfont.ttf',
            bold: 'pslxtext_bold-webfont.ttf',
          },
        };
        const docDefinition = {
          pageSize: 'A4',
          pageOrientation: 'landscape',
          // pageMargins: [60, 40, 60, 40],
          pageMargins: [10, 10, 10, 10],
          footer(currentPage, pageCount) {
            return `${currentPage.toString()} จาก ${pageCount}`;
          },
          content: [
            { text: 'รายงานสรุปยอด', fontSize: 18, bold: true, alignment: 'center' },
            { text: summaryDate, fontSize: 14, alignment: 'center' },
            { text: '    ', fontSize: 11, alignment: 'center' },
            {
              columns: [
                { width: '*', text: '' },
                {
                  width: 'auto',
                  table: {
                    headerRows: 1,
                    widths: [25, 80, 140, 140, 140, 100, 60, 60],
                    body: tableRows,
                  },
                  fontSize: 11,
                  alignment: 'center',
                  layout: {
                    fillColor(i) {
                      return (i % 2 === 0) ? '#efefef' : null;
                    },
                  },
                },
                { width: '*', text: '' },
              ],
            },
          ],
          defaultStyle: {
            font: 'pslxtext',
          },
        };

        const vm = this;
        pdfMake.createPdf(docDefinition).getDataUrl((dataURL) => {
          // check if this is IE or not
          if (window.navigator.msSaveOrOpenBlob) {
            // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            // create blob from data URL
            const byteString = atob(dataURL.split(',')[1]);
            // write the bytes of the string to an ArrayBuffer
            const ab = new ArrayBuffer(byteString.length);
            // create a view into the buffer
            const ia = new Uint8Array(ab);
            // set the bytes of the buffer to the correct values
            for (let i = 0; i < byteString.length; i += 1) {
              ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ia], {
              type: 'application/pdf',
            });
            const companyId = this.$store.getters.tenantId;
            const now = moment().tz(process.env.DEFAULT_TZ);
            const nowText = now.format('YYYY-MM-DD[T]hh:mm:ss');
            const pdfFilename = `bppayin-slip-${companyId}-${nowText}.pdf`;
            window.navigator.msSaveBlob(blob, pdfFilename);
          } else {
            vm.summaryPDFDataURL = dataURL;
            vm.isSummaryResultDialogShown = true;
          }
        });
      },
      requestDelete() {
        this.summaryDialogMode = 'delete';
        this.summaryDialogRequest = 'delete';
        this.summaryDialogTitle = 'รายการที่ต้องการลบ';
        this.isSummaryDialogShown = true;
      },
      requestExport(fileFormat) {
        this.summaryDialogMode = 'export';
        this.summaryDialogRequest = 'export';
        this.summaryDialogTitle = 'รายการที่ต้องการส่งออก';
        this.isSummaryDialogShown = true;
        this.exportFileFormat = fileFormat;
      },
      handleExportCommand(command) {
        this.requestExport(command);
      },
      handlePrintCommand(command) {
        this.summaryDialogMode = 'print';
        this.summaryDialogRequest = command;
        const payloadText = command === 'pay-in' ? 'Pay-in slip(s)' : 'รูปภาพ QR Code';
        this.summaryDialogTitle = `รายการที่ต้องการพิมพ์ ${payloadText}`;
        this.isSummaryDialogShown = true;
      },
      handleEmailCommand(command) {
        this.summaryDialogMode = 'email';
        this.summaryDialogRequest = command;
        const payloadText = command === 'pay-in' ? 'Pay-in slip(s)' : 'รูปภาพ QR Code';
        this.summaryDialogTitle = `รายการที่ต้องการส่ง ${payloadText} ทางอีเมล`;
        this.isSummaryDialogShown = true;
        // this.$message(`[Not Implemented] Requesting emailing ${command}`);
      },
      cancelSummaryDialog() {
        this.summaryDialogMode = '';
        this.summaryDialogRequest = '';
        this.summaryDialogTitle = '';
        this.isSummaryDialogShown = false;
      },
      confirmSummaryDialog() {
        // check mode (print or email)
        const mode = this.summaryDialogMode;
        const requestAsset = this.summaryDialogRequest;
        let isValid = false;
        if (mode === 'print') {
          if (requestAsset === 'pay-in') {
            isValid = true;
            this.requestPrintPayinSlip();
          } else if (requestAsset === 'qr') {
            isValid = true;
            // this.$message(`[Not Implemented] Requesting emailing ${requestAsset}`);
            this.requestPrintQR();
          }
        } else if (mode === 'email') {
          if (requestAsset === 'pay-in') {
            isValid = true;
            this.requestEmailPayinSlip();
          } else if (requestAsset === 'qr') {
            isValid = true;
            // this.$message(`[Not Implemented] Requesting emailing ${requestAsset}`);
            this.requestEmailPayinQR();
          }
        } else if (mode === 'delete' && requestAsset === 'delete') {
          isValid = true;
          this.requestDeletePayinSlip();
        } else if (mode === 'export' && requestAsset === 'export') {
          isValid = true;
          this.requestExportPayinSlip(this.exportFileFormat);
        }
        if (!isValid) {
          this.$message('Invalid request');
        }
        // clear state
        this.summaryDialogMode = '';
        this.summaryDialogRequest = '';
        this.summaryDialogTitle = '';
        this.isSummaryDialogShown = false;
      },
      forceDownloadPDF(pdfDataURL) {
        this.pdfContent = pdfDataURL;
        const companyId = this.$store.getters.tenantId;
        const now = moment().tz(process.env.DEFAULT_TZ);
        const nowText = now.format('YYYY-MM-DD[T]hh:mm:ss');
        this.pdfFilename = `bppayin-slip-${companyId}-${nowText}.pdf`;
        this.$nextTick(() => {
          const link = document.getElementById('slip-pdf-content');
          link.click();
        });
      },
      saveFile(blob, type, extension/* , contentType */) {
        const companyId = this.$store.getters.tenantId;
        const now = moment().tz(process.env.DEFAULT_TZ);
        const nowText = now.format('YYYY-MM-DD[T]hh:mm:ss');
        this.pdfFilename = `bppayin-${type}-${companyId}-${nowText}.${extension}`;
        // check if this is IE or not
        try {
          if (window.navigator.msSaveOrOpenBlob) {
            // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
            window.navigator.msSaveBlob(blob, this.pdfFilename);
          } else {
            // const file = new File([blob], this.pdfFilename, { type: contentType });
            // FileSaver.saveAs(file);
            FileSaver.saveAs(blob, this.pdfFilename);
          }
        } catch (err) {
          Raven.captureException(err, {
            extra: {
              err_payload: JSON.parse(JSON.stringify(err)),
            },
          });
        }
      },
      requestPrintPayinSlip() {
        this.isPrinting = true;
        let isGeneratePDF = true;
        if (this.selectedSlips.length >= 30) {
          isGeneratePDF = false;
        }
        this.$store.dispatch('PRINT_PAYER_SLIP', {
          profileId: this.profileId,
          slips: this.selectedSlips,
        }).then((res) => {
          this.isPrinting = false;
          if (isGeneratePDF) {
            const pdfContent = res;
            const pdfBlob = new Blob([pdfContent], {
              type: 'application/pdf',
            });
            this.saveFile(pdfBlob, 'slip', 'pdf', 'application/pdf');
          } else {
            // show message box instead
            let adminEmail = '';
            if (this.myAdminInfo && this.myAdminInfo.email) {
              adminEmail = this.myAdminInfo.email;
            }
            const msg = `เนื่องจากคุณสั่งพิมพ์ใบ Pay-In มากกว่า 30 ใบ ระบบจะทำการสร้างไฟล์และส่งให้คุณทางอีเมล ${adminEmail}`;
            this.$alert(msg, 'ส่งคำสั่งการสั่งพิมพ์เรียบร้อยแล้ว', {
              confirmButtonText: 'OK',
            }).then(() => {}).catch(() => {});
          }
          this.search();
        }).catch((msg) => {
          let errMsg = msg;
          if (typeof msg === 'object') {
            errMsg = JSON.stringify(msg);
          }
          this.isPrinting = false;
          this.pdfContent = null;
          this.pdfFilename = '';
          if (errMsg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(errMsg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
      },
      requestDeletePayinSlip() {
        this.isDeleting = true;
        this.$store.dispatch('DELETE_PAYER_SLIP', {
          profileId: this.profileId,
          slips: this.selectedSlips,
        }).then(() => {
          this.isDeleting = false;
          // this.selectedSlips.splice(0);
          this.selectedSlipsPaged = {};
          this.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ลบรายการผู้ชำระสำเร็จแล้ว',
          });
          // reload data
          this.search();
        }).catch((msg) => {
          this.isDeleting = false;
          let errMsg = msg;
          if (typeof msg === 'object') {
            errMsg = JSON.stringify(msg);
          }
          if (errMsg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(errMsg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
      },
      requestPrintQR() {
        this.isPrinting = true;
        const vm = this;
        let isDownloadable = true;
        if (this.selectedSlips.length > 50) {
          isDownloadable = false;
        }
        this.$store.dispatch('PRINT_PAYER_QR', {
          profileId: this.profileId,
          slips: this.selectedSlips,
        }).then((resContent) => {
          this.isPrinting = false;
          if (isDownloadable) {
            const extension = vm.selectedSlips.length > 1 ? 'zip' : 'png';
            const contentType = vm.selectedSlips.length > 1 ? 'application/octet-stream' : 'image/png';
            const contentBlob = new Blob([resContent], {
              type: contentType,
            });
            this.saveFile(contentBlob, 'QR', extension, contentType);
          } else {
            // show message box instead
            let adminEmail = '';
            if (this.myAdminInfo && this.myAdminInfo.email) {
              adminEmail = this.myAdminInfo.email;
            }
            const msg = `เนื่องจากคุณสั่งพิมพ์ QR มากกว่า 50 ใบ ระบบจะทำการสร้างไฟล์และส่งให้คุณทางอีเมล ${adminEmail}`;
            this.$alert(msg, 'ส่งคำสั่งการสั่งพิมพ์เรียบร้อยแล้ว', {
              confirmButtonText: 'OK',
            }).then(() => {}).catch(() => {});
          }
          this.search();
        }).catch((msg) => {
          let errMsg = msg;
          if (typeof msg === 'object') {
            errMsg = JSON.stringify(msg);
          }
          this.isPrinting = false;
          this.pdfContent = null;
          this.pdfFilename = '';
          if (errMsg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(errMsg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
      },
      makeXlSCol(refstr) {
        const o = [];
        const range = XLSX.utils.decode_range(refstr);
        for (let i = 0; i <= range.e.c; i += 1) {
          o.push({ name: XLSX.utils.encode_col(i), key: i });
        }
        return o;
      },
      /* requestExportPayinSlip(fileFormat) {
        if (fileFormat === 'csv') {
          this.requestExportPayinSlipCSV();
        } else {
          this.requestExportPayinSlipExcel();
        }
      },
      requestExportPayinSlipCSV() {
        // this.isExporting = true;
        console.log('export csv');
      }, */
      requestExportPayinSlip(fileFormat) {
        const isCSV = fileFormat === 'csv';
        this.isExporting = true;
        // prepare data for exporting
        const fieldLabels = this.xlsExportHeaderKey;
        const excludeFields = ['profile_id', 'company_id', 'created_at', 'updated_at', 'emailed_at', 'is_printed', 'is_sent', 'printed_at'];
        const jsonData = [];
        const slipSelectedData = [];

        Object.keys(this.selectedSlipsPaged).forEach((paged) => {
          this.selectedSlipsPaged[paged].forEach((slip) => {
            slipSelectedData.push(slip);
          });
        });
        // this.slipListData.forEach((item) => {
        slipSelectedData.forEach((item) => {
          const rowData = {};
          Object.keys(item).forEach((attr) => {
            if (excludeFields.indexOf(attr) === -1) {
              const label = fieldLabels[attr];
              let val = item[attr];
              if (label || attr === 'payer') {
                if (attr === 'issued_on') {
                  const issuedOnDate = moment(val).tz(process.env.DEFAULT_TZ);
                  if (issuedOnDate.isValid()) {
                    val = issuedOnDate.format('D/M/YY');
                  }
                }
                if (attr === 'payer') {
                  rowData[fieldLabels['payer.name']] = val.name;
                  rowData[fieldLabels['payer.email']] = val.email;
                  return;
                }
                if (attr === 'notification_msg') {
                  if (val === null) {
                    val = 'DEFAULT';
                  }
                }
                rowData[label] = val;
              }
            }
          });
          // SORT data for keys
          const xlsRowData = [];
          Object.keys(this.xlsTemplateHeadersKey).forEach((xlsKey) => {
            let val = rowData[xlsKey];
            if (typeof val === 'undefined') {
              val = '';
            }
            xlsRowData.push(val);
          });
          jsonData.push(xlsRowData);
        });
        // Convert back to XLSX
        // add header
        let xlsxData = [];
        xlsxData.push(Object.keys(this.xlsTemplateHeadersKey));
        // merge array
        xlsxData = _.concat(xlsxData, jsonData);

        const companyId = this.$store.getters.tenantId;
        const now = moment().tz(process.env.DEFAULT_TZ);
        const nowText = now.format('YYYY-MM-DD[T]hh:mm:ss');

        if (isCSV) {
          console.log('export CSV', xlsxData);
          /* let csvContent = '';
          xlsxData.forEach((rowData) => {
            csvContent += `"${rowData.join('","')}"\n`;
          }); */
          const csvContent = Papa.unparse(xlsxData, {
            quotes: true,
          });
          try {
            const csvFilename = `bppayin-slip-${companyId}-${nowText}.csv`;
            const blob = new Blob([csvContent], {
              type: 'application/octet-stream',
            });
            FileSaver.saveAs(blob, csvFilename);
          } catch (e) {
            this.$store.dispatch('ADD_ERROR_FLASH', JSON.stringify(e));
          }
        } else {
          // create new workbook
          const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
          const dataWorkbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(dataWorkbook, worksheet, 'SLIPS');
          try {
            const xlsFilename = `bppayin-slip-${companyId}-${nowText}.xlsx`;
            const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' };
            const wbout = XLSX.write(dataWorkbook, wopts);
            const blob = new Blob([wbout], {
              type: 'application/octet-stream',
            });
            FileSaver.saveAs(blob, xlsFilename);
          } catch (e) {
            this.$store.dispatch('ADD_ERROR_FLASH', JSON.stringify(e));
          }
        }
        this.isExporting = false;
      },
      requestEmailPayinSlip() {
        this.isEmailing = true;
        const emailSlipList = [];
        /* this.selectedSlips.forEach((slipId) => {
          this.slipListData.forEach((slip) => {
            if (slip.id === slipId && slip.payer.email.trim() !== '') {
              emailSlipList.push(slipId);
            }
          });
        }); */
        Object.keys(this.selectedSlipsPaged).forEach((paged) => {
          this.selectedSlipsPaged[paged].forEach((slip) => {
            if (slip.payer.email && slip.payer.email.trim() !== '') {
              emailSlipList.push(slip.id);
            }
          });
        });
        this.$store.dispatch('EMAIL_PAYER_SLIP', {
          profileId: this.profileId,
          slips: emailSlipList,
        }).then(() => {
          this.isEmailing = false;
          this.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ส่งคำร้องเพื่อส่งอีเมลรายการผู้ชำระสำเร็จแล้ว',
          });
          // reload data
          this.search();
        }).catch((msg) => {
          this.isEmailing = false;
          let errMsg = msg;
          if (typeof msg === 'object') {
            errMsg = JSON.stringify(msg);
          }
          if (errMsg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(errMsg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
      },
      requestEmailPayinQR() {
        this.isEmailing = true;
        const emailSlipList = [];
        /* this.selectedSlips.forEach((slipId) => {
          this.slipListData.forEach((slip) => {
            if (slip.id === slipId && slip.payer.email.trim() !== '') {
              emailSlipList.push(slipId);
            }
          });
        }); */
        Object.keys(this.selectedSlipsPaged).forEach((paged) => {
          this.selectedSlipsPaged[paged].forEach((slip) => {
            if (slip.payer.email && slip.payer.email.trim() !== '') {
              emailSlipList.push(slip.id);
            }
          });
        });
        this.$store.dispatch('EMAIL_PAYER_QR', {
          profileId: this.profileId,
          slips: emailSlipList,
        }).then(() => {
          this.isEmailing = false;
          this.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ส่งคำร้องเพื่อส่งอีเมลรายการ QR code ของผู้ชำระสำเร็จแล้ว',
          });
          // reload data
          this.search();
        }).catch((msg) => {
          this.isEmailing = false;
          let errMsg = msg;
          if (typeof msg === 'object') {
            errMsg = JSON.stringify(msg);
          }
          if (errMsg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(errMsg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
      },
      sumImportSlips(param) {
        const { columns } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (['selection', 'blank'].indexOf(column.type) !== -1 || column.label === 'ตัวเลือก') {
            // sums[index] = 'ยอดสุทธิ';
            sums[index] = '';
            return;
          }
          if (['rowNumber', 'ref1', 'ref2', 'is_printed', 'is_sent', 'id', 'payer.name', 'payer.email', 'notification_msg', 'remark'].indexOf(column.property) !== -1) {
            sums[index] = '';
            return;
          }
          if (column.type === 'index') {
            sums[index] = this.xlsDataRowsSorted.length;
            return;
          }
          const values = this.xlsDataRowsSorted.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            const colValue = numeral(values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              }
              return prev;
            }, 0));
            sums[index] = numeral(colValue).format('0,0.00');
          } else {
            sums[index] = '';
          }
        });
        return sums;
      },
      sumPagedSlips(param) {
        const { columns } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (['selection', 'blank'].indexOf(column.type) !== -1 || column.label === 'ตัวเลือก') {
            // sums[index] = 'ยอดสุทธิ';
            sums[index] = '';
            return;
          }
          if (['rowNumber', 'ref1', 'ref2', 'is_printed', 'is_sent', 'id', 'payer.name', 'payer.email', 'notification_msg', 'remark'].indexOf(column.property) !== -1) {
            sums[index] = '';
            return;
          }
          if (column.type === 'index') {
            sums[index] = this.slipListDataSorted.length;
            return;
          }
          const values = this.slipListDataSorted.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            const colValue = numeral(values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              }
              return prev;
            }, 0));
            sums[index] = numeral(colValue).format('0,0.00');
          } else {
            sums[index] = '';
          }
        });
        return sums;
      },
      sumSlips(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (['selection', 'blank'].indexOf(column.type) !== -1 || column.label === 'ตัวเลือก') {
            // sums[index] = 'ยอดสุทธิ';
            sums[index] = '';
            return;
          }
          if (['ref1', 'ref2', 'is_printed', 'is_sent', 'id', 'payer.name', 'payer.email', 'notification_msg', 'remark'].indexOf(column.property) !== -1) {
            sums[index] = '';
            return;
          }
          if (column.type === 'index') {
            sums[index] = data.length;
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            const colValue = numeral(values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              }
              return prev;
            }, 0));
            sums[index] = numeral(colValue).format('0,0.00');
          } else {
            sums[index] = '';
          }
        });
        return sums;
      },
      // IMPORT XLSX
      handleImportSlipsCommand(command) {
        if (command === 'import' || command === 'import-csv') {
          this.isImportDialogShown = true;
          this.importFileFormat = command === 'import' ? 'xlsx' : 'csv';
        }
      },
      handleBeforeXLSUpload(file) {
        let isValid = true;
        const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const isCSV = file.type === 'text/csv' || file.name.split('.').pop() === 'csv';
        // check file type
        if (!isXLSX && !isCSV) {
          this.$message.error('กรุณานำเข้าด้วยไฟล์ XLSX หรือ CSV เท่านั้น!');
          isValid = false;
        }
        // check format
        if (isValid) {
          this.xlsUpdateFile = file;
        }
        return true;
      },
      handleXLSImport() {
        if (this.xlsUpdateFile) {
          const vm = this;
          vm.isImporting = true;
          vm.xlsDataRows.splice(0);
          vm.xlsSkipRows.splice(0);
          vm.xlsErrorRows.splice(0);
          const xlsxReader = new FileReader();
          xlsxReader.addEventListener('load', () => {
            let xlsxData = [];
            if (this.importFileFormat === 'xlsx') {
              let dataURL = xlsxReader.result;
              const pos = dataURL.indexOf('base64,');
              if (pos !== -1) {
                const dataIndicator = dataURL.substring(0, pos + 7);
                dataURL = dataURL.replace(dataIndicator, '');
                const wb = XLSX.read(dataURL, { type: 'base64', cellDates: true, cellNF: false, cellText: false });
                const ws = wb.Sheets[wb.SheetNames[0]];
                // iterate all cell
                // check for date type cell, then adjust format
                Object.keys(ws).forEach((cellAddress) => {
                  const cell = ws[cellAddress];
                  if (cell.t === 'd') {
                    const cellDate = moment(cell.v).tz(process.env.DEFAULT_TZ);
                    if (cellDate.isValid()) {
                      cell.w = cellDate.format('D/M/YY');
                    }
                  }
                });
                xlsxData = XLSX.utils.sheet_to_json(ws, { header: 1 });
              }
            } else if (this.importFileFormat === 'csv') {
              const csvContent = xlsxReader.result;
              const csvResults = Papa.parse(csvContent);
              if (csvResults.data.length > 0) {
                xlsxData = csvResults.data;
              }
            }
            if (xlsxData.length > 0) {
              for (let rowNumber = 0; rowNumber < xlsxData.length; rowNumber += 1) {
                // xlsxData.forEach((row, rowNumber) => {
                const row = xlsxData[rowNumber];
                // skip row 1, it is header
                if (rowNumber > 0) {
                  // check if row has 8 column or not.
                  // If yes, just add 1 more as `remark` column is not read from file
                  if (row.length <= 8) {
                    const colCount = 9 - row.length;
                    for (let cc = 0; cc < colCount; cc += 1) {
                      row.push('');
                    }
                  }
                  let blankCount = 0;
                  let mustSkip = false;
                  // check blank row
                  for (let sr = 0; sr < row.length; sr += 1) {
                    if (typeof row[sr] !== 'undefined' && row[sr].toString().trim() === '') {
                      blankCount += 1;
                    }
                  }
                  if (blankCount >= row.length) {
                    mustSkip = true;
                  }
                  if (!mustSkip) {
                    let shouldSkip = false;
                    let keyCount = 0;
                    const rowData = {};
                    const templateHeaderCount = vm.xlsTemplateHeaders.length;
                    vm.xlsTemplateHeaders.forEach((header, headerIndex) => {
                      for (let c = 0; c < row.length; c += 1) {
                        const cellValue = row[c] || '';
                        const cellIndex = c;
                        if (cellIndex === headerIndex) {
                          let isValid = true;
                          const attr = vm.xlsTemplateHeadersKey[header];
                          let val = cellValue;
                          // console.log(header, ' => ', attr, ' = ', val);
                          // transform & check validity
                          if (['rowNumber', 'id'].indexOf(attr) !== -1) {
                            if (isNaN(parseInt(val, 10))) {
                              isValid = false;
                              if (attr === 'id' && val.toString().trim() === '') {
                                isValid = true;
                              }
                            }
                          }
                          if (attr === 'amount') {
                            if (isNaN(parseInt(val, 10))) {
                              isValid = false;
                            } else {
                              // round 2 digit
                              const valNumeral = numeral(val);
                              val = numeral(val).format('0.00');
                              if (valNumeral.value() > 99999999.99) {
                                isValid = false;
                              }
                            }
                          }
                          if (['payer.name', 'ref1'].indexOf(attr) !== -1) {
                            if (val.toString().trim() === '') {
                              isValid = false;
                            }
                            if (attr === 'payer.name') {
                              // max length 40 chars
                              val = val.substr(0, 40);
                            }
                          }
                          if (attr === 'payer.email') {
                            // check email format
                            if (val && val.toString().trim() !== '') {
                              const emailRegEx = new XRegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$', 'g');
                              isValid = emailRegEx.test(val);
                            }
                          }
                          if (['ref1', 'ref2'].indexOf(attr) !== -1) {
                            // max length 20 chars
                            val = val.substr(0, 20);

                            if (attr === 'ref1' && val && val.toString().trim() === '') {
                              isValid = false;
                            } else if (val && val.toString().trim() !== '') {
                              // validate format
                              const refRegEx = new XRegExp('^[0-9A-Z]{0,20}$', 'g');
                              isValid = refRegEx.test(val);
                            }
                          }
                          if (['notification_msg', 'remark'].indexOf(attr) !== -1) {
                            // max length 100 chars
                            val = val.substr(0, 100);
                          }
                          if (attr === 'issued_on') {
                            const issuedOnDate = moment(val, 'D/M/YY').tz(process.env.DEFAULT_TZ);
                            if (issuedOnDate.isValid()) {
                              val = issuedOnDate.format('YYYY-MM-DD');
                            } else {
                              isValid = false;
                            }
                          }
                          if (isValid) {
                            keyCount += 1;
                            if (typeof val !== 'undefined' && val !== null) {
                              rowData[attr] = val.toString().trim();
                            } else {
                              rowData[attr] = val;
                            }
                          } else {
                            shouldSkip = true;
                          }
                        }
                      }
                    });
                    // console.log('shouldSkip', shouldSkip, rowData);
                    if (keyCount === templateHeaderCount) {
                      // transform rowData for display
                      const tableRowData = {};
                      Object.keys(rowData).forEach((key) => {
                        let val = rowData[key];
                        if (['id', 'amount'].indexOf(key) !== -1) {
                          // convert to number
                          if (val.toString().trim() !== '') {
                            val = Number(val);
                          } else if (key === 'id') {
                            // id is not presented, set it to null.
                            // otherwise, API will complain for Number type
                            val = null;
                          }
                        }
                        if (key.indexOf('payer') !== -1) {
                          if (typeof tableRowData.payer === 'undefined') {
                            tableRowData.payer = {
                              name: '',
                              email: '',
                            };
                          }
                          tableRowData.payer[key.replace('payer.', '')] = val;
                        } else if (key === 'notification_msg') {
                          if (val === 'DEFAULT') {
                            if (this.profile) {
                              tableRowData[key] = this.profile.notification_msg;
                            }
                          } else {
                            tableRowData[key] = val;
                          }
                        } else {
                          tableRowData[key] = val;
                        }
                      });
                      // add rowNumber
                      tableRowData.rowNumber = vm.xlsDataRows.length + 1;
                      vm.xlsDataRows.push(tableRowData);
                    }
                    if (shouldSkip) {
                      vm.xlsSkipRows.push(row);
                    }
                  }
                }
              }
              // });
              if (vm.xlsDataRows.length === 0 && vm.xlsSkipRows.length === 0) {
                vm.$store.dispatch('ADD_ERROR_FLASH', 'กรุณานำเข้าไฟล์ XLSX ที่มีข้อมูลสำหรับนำเข้า');
              }
              if (vm.xlsDataRows.length > 0) {
                vm.xlsDataRowsSorted = JSON.parse(JSON.stringify(vm.xlsDataRows));
              }
            } else {
              vm.$store.dispatch('ADD_ERROR_FLASH', 'ไม่สามารถอ่านข้อมูลไฟล์ XLSX ที่ต้องการได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
            }
            vm.isImporting = false;
          }, false);
          try {
            if (this.importFileFormat === 'xlsx') {
              xlsxReader.readAsDataURL(this.xlsUpdateFile);
            } else {
              xlsxReader.readAsText(this.xlsUpdateFile);
            }
          } catch (e) {
            console.error(e);
            this.$store.dispatch('ADD_ERROR_FLASH', 'ไม่สามารถอ่านข้อมูลไฟล์ XLSX ที่ต้องการได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
            vm.isImporting = false;
          }
        }
      },
      cancelImportDialog() {
        this.isImporting = false;
        this.isImportDialogShown = false;
        this.xlsUpdateFile = null;
        this.xlsDataRows.splice(0);
        this.xlsErrorRows.splice(0);
        this.xlsSkipRows.splice(0);
      },
      confirmImportDialog() {
        this.isImporting = true;
        const reqPayload = {
          profileId: this.profileId,
          payload: this.xlsDataRows,
        };
        this.$store.dispatch('IMPORT_BILLER_SLIPS', reqPayload).then(() => {
          this.isImporting = false;
          this.isImportDialogShown = false;
          this.xlsUpdateFile = null;
          this.xlsDataRows.splice(0);
          this.xlsErrorRows.splice(0);
          this.xlsSkipRows.splice(0);
          this.search();
        }).catch((msg) => {
          this.isImporting = false;
          if (msg) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
      },
      downloadXLSTemplate() {
        // create new workbook
        const xlsxData = [];
        xlsxData.push(this.xlsTemplateHeaders);
        if (this.importFileFormat === 'xlsx') {
          const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
          const dataWorkbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(dataWorkbook, worksheet, 'SLIPS');
          const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' };
          const wbout = XLSX.write(dataWorkbook, wopts);

          try {
            const xlsFilename = 'bppayin-slip-import-template.xlsx';
            const blob = new Blob([wbout], {
              type: 'application/octet-stream',
            });
            FileSaver.saveAs(blob, xlsFilename);
          } catch (e) {
            this.$store.dispatch('ADD_ERROR_FLASH', JSON.stringify(e));
          }
        } else {
          /* let csvContent = '';
          xlsxData.forEach((rowData) => {
            csvContent += `"${rowData.join('","')}"\n`;
          }); */
          const csvContent = Papa.unparse(xlsxData, {
            quotes: true,
          });
          try {
            const csvFilename = 'bppayin-slip-import-template.csv';
            const blob = new Blob([csvContent], {
              type: 'application/octet-stream',
            });
            FileSaver.saveAs(blob, csvFilename);
          } catch (e) {
            this.$store.dispatch('ADD_ERROR_FLASH', JSON.stringify(e));
          }
        }
      },
      // -- END IMPORT XLSX
      closeSummaryResultDialog() {
        this.isSummaryResultDialogShown = false;
        this.summaryPDFDataURL = null;
      },
      searchOptionCollapseChange() {
        this.$store.dispatch('TOGGLE_BILLER_SLIP_SEARCH_OPTION');
      },
      submitForm() {
        // clear selected slips
        // this.selectedSlips.splice(0);
        this.selectedSlipsPaged = {};
        this.search();
      },
      resetForm() {
        this.$refs.searchForm.resetFields();
        this.searchForm.amount__from = null;
        this.searchForm.amount__to = null;
        this.searchForm.issued_on__from = null;
        this.searchForm.issued_on__to = null;
        this.searchForm.payee__name = null;
        this.searchForm.ref1 = null;
        this.searchForm.ref2 = null;
        this.searchForm.is_printed = 'ทั้งหมด';
        this.searchForm.limit = defaultLimit;
        this.searchForm.offset = defaultOffset;
        this.searchForm.id__in = null;
        this.searchForm.is_sent = 'ทั้งหมด';
        this.searchForm.order_by = 'issued_on';
        this.searchForm.order_dir = 'desc';
        this.search();
      },
      updateMaskAmount(field) {
        this.maskValue(this.searchForm, field, this.mask.amountMask);
      },
      updateMaskRefCode() {
        if (this.searchForm.ref1) {
          this.searchForm.ref1 = this.searchForm.ref1.toUpperCase();
          this.maskValue(this.searchForm, 'ref1', this.mask.refCode);
        }
        if (this.searchForm.ref2) {
          this.searchForm.ref2 = this.searchForm.ref2.toUpperCase();
          this.maskValue(this.searchForm, 'ref2', this.mask.refCode);
        }
      },
      maskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          const resolvedValue = mask.resolve(val.toString());
          form[field] = resolvedValue;
        }
      },
      unmaskValue(form, field, maskOptions) {
        const mask = createMask(maskOptions);
        const val = form[field];
        if (val) {
          mask.resolve(val.toString());
          form[field] = mask.unmaskedValue;
        }
      },
      /* eslint prefer-arrow-callback: 0 */
      handleInput: _.debounce(function handleInputFn(evt, refName, maskName) {
        if (['searchForm.ref1', 'searchForm.ref2'].indexOf(refName) !== -1) {
          if (this.searchForm.ref1) {
            this.searchForm.ref1 = this.searchForm.ref1.toUpperCase();
          }
          if (this.searchForm.ref2) {
            this.searchForm.ref2 = this.searchForm.ref2.toUpperCase();
          }
        }
        this.$nextTick(() => {
          helpers.handleInput(evt,
            this.$refs, refName,
            this.mask, maskName);
        });
      }, process.env.HANDLE_INPUT_DEBOUNCE_INTERVAL, { tailing: true }),
      // pagination stuffs
      updateImportDataRows() {
        // console.log(page);
      },
      updateSlipListDataRows(page) {
        if (!this.isChangingPage) {
          this.isChangingPage = true;
          // get new data from the latest page
          let offsetIndex = (page - 1) * this.slipListDataItemPerPage;
          if (offsetIndex >= this.slipListTotalItem) {
            offsetIndex = this.slipListTotalItem - 1;
          }
          this.searchForm.offset = offsetIndex;
          this.search().then(() => {
            this.isChangingPage = false;
          });
        }
      },
      updatePagedSelection(page) {
        // update selection
        let currentSelectedSlipListPageData = null;
        if (typeof this.selectedSlipsPaged[`_${page}`] !== 'undefined') {
          const slipList = JSON.parse(JSON.stringify(this.selectedSlipsPaged[`_${page}`]));
          currentSelectedSlipListPageData = slipList.map(slip => slip.id);
        }
        if (currentSelectedSlipListPageData) {
          this.slipListDataPaged.forEach((row) => {
            this.$refs.slipListTable
              .toggleRowSelection(row, currentSelectedSlipListPageData.indexOf(row.id) !== -1);
          });
        }
      },
      dynamicSort(prop, type) {
        let sortOrder = 1;
        if (prop[0] === '-') {
          sortOrder = -1;
          prop = prop.substr(1);
        }
        return (a, b, cb) => {
          // const result = (a[prop] < b[prop]) ? -1 : (a[prop] > b[prop]) ? 1 : 0;
          let result = 0;
          let aValue = a[prop];
          let bValue = b[prop];
          if (type === 'date') {
            const aDate = moment(aValue).tz(process.env.DEFAULT_TZ);
            if (aDate.isValid()) {
              aValue = Number(aDate.format('X'));
            }
            const bDate = moment(bValue).tz(process.env.DEFAULT_TZ);
            if (bDate.isValid()) {
              bValue = Number(bDate.format('X'));
            }
          } else if (type === 'number') {
            aValue = Number(aValue);
            bValue = Number(bValue);
          }
          if (aValue < bValue) {
            result = -1;
          } else if (aValue > bValue) {
            result = 1;
          }
          return cb(null, result * sortOrder);
        };
      },
      importTableSorted({ prop, order }) {
        if (prop && order) {
          /* this.isSortingImport = true;
          let type = 'string';
          let sortProp = prop;
          if (order === 'descending') {
            sortProp = `-${sortProp}`;
          }
          if (prop === 'issued_on') {
            // sort by date
            type = 'date';
          } else if (['amount', 'id'].indexOf(prop) !== -1) {
            // sort by number
            type = 'number';
          }
          asyncMergeSort(this.xlsDataRows,
            this.dynamicSort(sortProp, type),
            (err, sorted) => {
              this.isSortingImport = false;
              if (!err) {
                this.xlsDataRowsSorted = sorted;
              }
            }); */
          this.searchForm.order_by = prop;
          this.searchForm.order_dir = order === 'descending' ? 'desc' : 'asc';
        } else {
          // reset sorting
          // this.xlsDataRowsSorted = JSON.parse(JSON.stringify(this.xlsDataRows));
          this.searchForm.order_by = 'issued_on';
          this.searchForm.order_dir = 'desc';
        }
        // clear selection
        // this.selectedSlips.splice(0);
        this.selectedSlipsPaged = {};
        this.search();
        // force hide loading after 5 seconds
        /* setTimeout(() => {
          if (this.isSortingImport) {
            this.isSortingImport = false;
          }
        }, 5000); */
      },
      dataTableSorted({ prop, order }) {
        if (prop && order) {
          this.searchForm.order_by = prop;
          this.searchForm.order_dir = order === 'descending' ? 'desc' : 'asc';
        } else {
          // reset sorting
          this.searchForm.order_by = 'issued_on';
          this.searchForm.order_dir = 'desc';
        }
        this.selectedSlipsPaged = {};
        this.search();
      },
      clearSelection() {
        this.selectedSlipsPaged = {};
        this.$refs.slipListTable.clearSelection();
      },
    },
    mounted() {
      if (this.$store.getters.slipSearchQuery) {
        Object.keys(this.searchForm).forEach((key) => {
          // if (this.$store.getters.slipSearchQuery[key]) {
          let val = this.$store.getters.slipSearchQuery[key];
          if (key === 'is_printed') {
            if (val === true) {
              val = 'พิมพ์แล้ว';
            } else if (val === false) {
              val = 'ยังไม่พิมพ์';
            } else if (val === null) {
              val = 'ทั้งหมด';
            }
          } else if (key === 'is_sent') {
            if (val === true) {
              val = 'ส่งแล้ว';
            } else if (val === false) {
              val = 'ยังไม่ส่ง';
            } else if (val === null) {
              val = 'ทั้งหมด';
            }
          } else if (key === 'limit') {
            if (val === null) {
              val = defaultLimit;
            }
          } else if (key === 'offset') {
            if (val === null) {
              val = defaultOffset;
            }
          }
          this.$set(this.searchForm, key, val);
          // }
        });
      }
      this.search()
    },
    watch: {
      // vm.xlsDataRowsSorted = JSON.parse(JSON.stringify(vm.xlsDataRows));
      slipListData(newList, oldList) {
        if (newList && oldList !== newList) {
          this.slipListDataSorted = JSON.parse(JSON.stringify(newList));
        }
      },
      slipListDataSorted() {
        this.isSortingData = false;
      },
      xlsDataRowsSorted() {
        this.isSortingImport = false;
      },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.$store.dispatch('SELECT_CURRENT_BILLER_PROFILE', vm.profileId);
      });
    },
    beforeRouteLeave(to, from, next) {
      // clear current selection
      this.$store.dispatch('SELECT_CURRENT_BILLER_PROFILE', '');
      next();
    },
  };
  export default BillerProfileDetailView;
</script>

<style lang="scss">
  .biller-profile-detail-page {
    &.page-content {
      .page-header.-with-action-buttons {
        .action-buttons {
          .el-dropdown__caret-button {
            padding-left: 10px;
            padding-right: 10px;
            margin-right: 10px;
          }
        }
      }
    }
    .biller-profile-logo-holder {
      margin-bottom: 20px;
      padding-left: 20px;
      padding-right: 20px;

      .logo-holder {
        margin-right: 10px;
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        background: #fff;
        border: 1px solid #000;
        border-radius: 4px;
        padding: 2px;
        .logo {
          max-width: 46px;
          height: auto;
          display: block;
          margin: 0 auto;
        }
      }
    }
    .slip-search-filder-panel {
      margin-top: 20px;
    }
    .slip-list-table {
      .control-panel {
        .title {
          display: inline-block;
          margin: 0 0 10px;
          font-size: 18px;
        }
        .action-buttons {
          margin-bottom: 10px;
          text-align: right;
        }
      }
    }
  }
  .slip-search-form {
    padding: 20px;
    background: #efefef;
    border-radius: 4px;
    width: 600px;

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 100%;
    }

    &.el-form--label-top .el-form-item__label {
      line-height: 1;
    }
    .el-form-item {
      // margin-bottom: 10px;
    }

    .el-radio-group {
      display: block;
      .el-radio, .el-radio-button {
        width: 33.33%;
        .el-radio-button__inner {
          width: 100%;
        }
      }
      .el-radio+.el-radio {
        margin-left: 0;
      }
    }

    .option-group-label {
      .el-form-item__label {
        padding-bottom: 5px;
        line-height: 1;
        display: block;
        border-bottom: 1px dotted #555;
        margin-bottom: 10px;
      }
    }

    .search-option-buttons {
      border-top: 1px solid #ccc;

      .el-form-item {
        margin-bottom: 10px;
      }

      .search-btn {
        float: right;
      }
    }
  }
  .search-option-collapse {
    margin-bottom: 20px;
    .el-collapse-item__header {
      font-size: 16px;
      .el-collapse-item__arrow {
        display: none;
      }
    }
    .hide-search-option-btn {
      color: red;
    }
    .filter-count {
      color: red;
      font-size: 14px;
      float: right;
    }
  }
  .slip-search-filter {
    .title {
      font-size: 18px;
      margin: 0 0 10px;
    }
  }
  .slip-selected-count {
    color: red;
    font-weight: bold;
    // float: left;
    line-height: 42px;
    text-align: right;
    display: inline-block;
    margin-right: 10px;
  }
  #summaryPdfViewerDialog {
    .el-dialog__body {
      padding: 0;
      height: 100%;
    }
  }
  #summaryPdfViewer {
    border: 0;
    width: 100%;
    height: 100%;
    /* left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: absolute; */
  }
  .notification_msg-col .cell {
    padding-left: 5px!important;
    padding-right: 5px!important;;
  }
  .slip-list-table {
    .cell {
      padding-left: 5px!important;
      padding-right: 5px!important;
    }
    .status-row {
      color: #cccccc;
      font-size: 12px;
      line-height: 1.5;

      span {
        display: inline-block;
        width: 40px;
      }

      &.success {
        color: #67c23a;
        font-weight: bold;

        .el-icon-check {
          background: #67c23a;
          color: #fff;
          padding: 2px;
          font-weight: bold;
          border-radius: 4px;
          margin-left: 4px;
        }
      }
    }
  }
  .profile-detail-info {
    .row-center {
      text-align: center;
    }
    .bill-payment-info-row {
      line-height: 1.3;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/biller/profile-view.vue